import { useState } from 'react'

import { CustomSelect, type OptionItem } from '@wartek-id/select'
import { Text } from '@wartek-id/text-v1'

import { Header } from 'app/KinerjaShared/components/Header'
import { FILTER_STATE } from 'app/KinerjaTimPenilaiPSPage/utils/status'
import TablePerencanaanPS from 'app/KinerjaTimPenilaiPSPage/components/TablePerencanaanPS'
import usePerencanaanList from 'app/KinerjaTimPenilaiPSPage/hooks/usePerencanaanList'
import useBasePath from 'app/KinerjaTimPenilaiPSPage/hooks/useBasePath'

import type {
  PerencanaanFilterState,
  TPerencanaanSummary,
} from 'types/kinerja-tim-penilai-ps'

const mapping: Record<
  Exclude<
    PerencanaanFilterState,
    | 'BELUM_DIAJUKAN_PENGAWAS'
    | 'DAPAT_DISETUJUI_SEKALIGUS'
    | 'DISETUJUI_PEJABAT_PENILAI_KINERJA'
  >,
  keyof TPerencanaanSummary
> = {
  ALL: 'total',
  SUDAH_DIAJUKAN_PENGAWAS: 'sudahDiajukanPengawas',
  BELUM_DISETUJUI_PEJABAT_PENILAI_KINERJA:
    'belumDisetujuiPejabatPenilaiKinerja',
  DIARAHKAN_REVISI_OLEH_TIM_KERJA: 'diarahkanRevisiOlehTimKerja',
  DIARAHKAN_REVISI_OLEH_PEJABAT_PENILAI_KINERJA:
    'diarahkanRevisiOlehPejabatPenilaiKinerja',
  SUDAH_DIREVISI_PENGAWAS: 'sudahDirevisiPengawas',
}

export default function TimPenilaiDaftarPSPage() {
  const [activeFilterState, setActiveFilterState] =
    useState<PerencanaanFilterState>('ALL')

  const { basePath, isPPKPengawasSekolahUrl: isPPKPengawasSekolah } =
    useBasePath()
  const { data, summary, isLoading, isFetched } = usePerencanaanList({
    filter: activeFilterState,
  })

  return (
    <div className="px-24 py-6 m-auto max-w-7xl">
      <Header title="Daftar Perencanaan Kinerja" className="mt-6" />
      <div className="mt-12 bg-white border rounded border-gray-30">
        <div className="p-6 pb-0 space-y-1">
          <Text variant="heading-md" as="h2">
            Periksa Perencanaan Pengawas Sekolah
          </Text>
          <Text color="subdued">
            {isPPKPengawasSekolah
              ? 'Anda dapat setujui Perencanaan atau arahkan Pengawas Sekolah untuk revisi.'
              : 'Anda dapat berikan rekomendasi persetujuan ke Pejabat Penilai Kinerja atau arahkan Pengawas Sekolah untuk revisi.'}
          </Text>
        </div>

        <div className="flex p-6">
          {isFetched && (
            <CustomSelect
              className="w-[650px]"
              value={{
                name: `${FILTER_STATE[activeFilterState]} (${
                  summary[mapping[activeFilterState as keyof typeof mapping]]
                })`,
                value: activeFilterState,
              }}
              onChange={(e: OptionItem) =>
                setActiveFilterState(e.value as PerencanaanFilterState)
              }
              options={
                Object.keys(mapping).map((state) => ({
                  name: `${FILTER_STATE[state]} (${
                    summary[mapping[state as keyof typeof mapping]]
                  })`,
                  value: state as PerencanaanFilterState,
                })) as OptionItem[]
              }
              placeholder="Pilih di sini"
            />
          )}
        </div>

        <TablePerencanaanPS
          basePath={basePath}
          data={data?.data ?? []}
          isLoading={isLoading}
        />
      </div>
    </div>
  )
}
